import { ImportWizardPhase } from '../../typings/importWizard';

export const UPDATE_IMPORT_WIZARD_STEP = 'UPDATE_IMPORT_WIZARD_STEP';
export type UPDATE_IMPORT_WIZARD_STEP = typeof UPDATE_IMPORT_WIZARD_STEP;

export interface UpdateImportWizardStep {
    type: UPDATE_IMPORT_WIZARD_STEP;
    phase: ImportWizardPhase;
}

export function updateImportWizardStepAction(phase: ImportWizardPhase): UpdateImportWizardStep {
    return {
        type: UPDATE_IMPORT_WIZARD_STEP,
        phase
    };
}
